export default __webpack_public_path__ + "static/media/endRound12.e0be274e.mp3";